import { useEffect } from 'react'
import { APP_REGISTRY } from '../../model/appRegistry.js'
import { headerStore } from '../../state/headerStore'
import { media } from '../../styles/media'
import styled from 'styled-components'
import useTranslation from '../../hooks/useTranslation'
import useUserPermissions from '../../hooks/useUserPermissions'
import CardTile from '../generic/Cards'

import MobileNavBar from '../mobileNav/MobileNavBar'
import { DeadSpace } from '../mobileNav/MobileNavBar'

const Block = styled.div`
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
`

// On a wide screen the title is in the header.
const CardListTitle = styled.h1`
    margin-bottom: 1.25rem;

    ${media.laptop} {
        display: none;
    }
`

const PendingWrapper = styled.div`
    max-width: 480px;
`

const CardList = () => {
    const { t } = useTranslation()
    const { isOwner, isPending, apps, isLoading } = useUserPermissions()

    // The menu has no entry for /home, so the page names itself in the header.
    useEffect(() => {
        headerStore.title = 'app.list.title'
        return () => { headerStore.title = null }
    }, [])

    const appList = Object.entries(APP_REGISTRY).map(([appId, app]) => ({
        appId,
        appTitle:       app.title,
        appDescription: app.description,
        appUrl:         app.url,
        appIcon:        app.icon,
        ownerOnly:      app.ownerOnly,
    }))

    const visibleApps = isOwner
        ? appList
        : appList.filter(app => !app.ownerOnly && apps.includes(app.appId))

    return (
        <>
            <CardListTitle name='CardListTitle' data-testid='home.apps'>{t('app.list.title')}</CardListTitle>

            {!isLoading && isPending ? (
                <PendingWrapper>
                    <h2>{t('home.pending.title')}</h2>
                    <p>{t('home.pending.message')}</p>
                </PendingWrapper>
            ) : (
                <Block>
                    {visibleApps.map(
                        (item, i) => {
                            return <CardTile key={i} data={item} />
                        }
                    )}
                </Block>
            )}

            <MobileNavBar />
            <DeadSpace />
        </>
    )
}

export default CardList
